/* Jewelry Depot — Sticky Add-to-Bag Bar (Impulse v8.2.1)
   States: hidden | active | sold-out | added                       2026-05-23 */
(() => {
  const bar = document.getElementById('jd-sticky-atc');
  if (!bar) return;

  // Escape any transformed ancestor that would capture position:fixed.
  if (bar.parentElement !== document.body) document.body.appendChild(bar);

  // NOTE: do NOT filter `:not([disabled])` — Impulse renders the ATC disabled
  // until its product-form JS hydrates. The IntersectionObserver only needs
  // the position of whichever anchor we settle on.
  const ATC_SEL   = 'product-form button[type="submit"], .product-form__submit, button[name="add"], form[action*="/cart/add"] button[type="submit"]';
  const MODAL_CLS = ['js-drawer-open', 'cart-open', 'modal-open', 'video-modal-open'];
  const OPEN_EVTS = ['drawerOpen', 'modalOpen', 'cart:open'];

  // Anchor the reveal gate to the native ATC button: the bar reveals ONLY after the
  // button has scrolled above the top of the viewport; while it's visible — or still
  // below the fold on initial load — the bar stays hidden.
  // JD 2026-07-02: on a SOLD-OUT PDP there is no native ATC (product-form renders the
  // sold-out CONTACT US box instead), so anchor to that box's CONTACT US trigger
  // ([data-jd-soldout-open]). Same behaviour: hidden on first load, revealed only once
  // the in-page CONTACT US button has scrolled out of view above the top.
  const nativeAtc  = document.querySelector(ATC_SEL);
  const soldOut    = bar.dataset.inStock !== 'true';
  const soldOutBtn = document.querySelector('[data-jd-soldout-open]');
  const anchorEl   = (soldOut && soldOutBtn) ? soldOutBtn : nativeAtc;
  if (!anchorEl) return;

  // JD-CUSTOM 2026-06-21: on ring PDPs the ring-size selector (jd-ring-size-selector)
  // OWNS the native ATC button state. The sticky bar must NEVER disable it or relabel
  // it "Added" — especially on load, when these 1-of-a-kind rings are already in the
  // cart (checkCartForVariant would otherwise flip it to disabled/"Added" on refresh).
  const isRingPdp = !!document.querySelector('[data-jd-ring-size]');

  const s = {
    revealed: false, modalOpen: false, ready: false, busy: false,
    added: false,
    inStock: bar.dataset.inStock === 'true',
  };

  // Mirror in-cart state onto the native ATC button (class + disabled + text).
  //
  // nativeSynced starts false so the very first sync(false) is a no-op. render()
  // calls this on every pass, and without the guard each one would clear
  // `disabled` on a button we never locked — re-enabling a button that Impulse
  // itself disabled (sold out, or not yet hydrated) and rewriting DOM on every
  // scroll tick. We only ever undo a lock we applied.
  let origAtcHtml = null;
  let nativeSynced = false;
  const syncNativeAtc = (isInCart) => {
    if (!nativeAtc) return;
    if (isRingPdp) return;   // ring PDP: never disable/relabel the native ATC (always-active rule)
    if (nativeSynced === isInCart) return;
    nativeSynced = isInCart;
    if (isInCart) {
      if (origAtcHtml === null) origAtcHtml = nativeAtc.innerHTML;
      nativeAtc.classList.add('btn--in-cart');
      nativeAtc.disabled = true;
      nativeAtc.innerHTML = '&#10003; Added to Shopping Bag';
    } else {
      nativeAtc.classList.remove('btn--in-cart');
      nativeAtc.disabled = false;
      if (origAtcHtml !== null) { nativeAtc.innerHTML = origAtcHtml; origAtcHtml = null; }
      // Drop the companion confirmation block theme.js appends on a successful add.
      nativeAtc.closest('form[action*="/cart/add"]')
        ?.querySelectorAll('.jd-cart-success-msg')
        .forEach(m => m.remove());
    }
  };

  const render = () => {
    // Keep the native in-page ATC button mirrored to cart state regardless of
    // whether the sticky bar is revealed — the native button lives mid-page,
    // not at the scroll-gated bottom, so it should always reflect "in cart".
    // syncNativeAtc is idempotent, so calling it every render is safe.
    syncNativeAtc(s.added);

    // Reveal gate comes BEFORE the in-cart ('added') check: the bar must stay
    // hidden while the ADD TO SHOPPING BAG button is still in view (or below
    // the fold on initial load) EVEN when this one-of-a-kind piece is already
    // in the cart. Only once the button has scrolled above the top of the
    // viewport (revealed === true) do we surface any visible state.
    const n = s.modalOpen                                    ? 'hidden'
            : (!s.ready || !s.revealed)                      ? 'hidden'
            : s.added                                        ? 'added'
            : !s.inStock                                     ? 'sold-out'
            :                                                  'active';
    if (bar.dataset.state === n) return;
    bar.dataset.state = n;
    bar.setAttribute('aria-hidden', n === 'hidden');
    bar.hidden = n === 'hidden';
    // JD-CUSTOM 2026-06-27: while the sticky ATC bar is visible, flag <html> so
    // CSS can hide the Shopify Inbox chat launcher (it's an app embed rendered
    // OUTSIDE this bar, so a descendant selector can't reach it). Mirrors the
    // html.jd-cart-drawer-open pattern in snippets/cart-drawer.liquid.
    document.documentElement.classList.toggle('jd-sticky-atc-visible', n !== 'hidden');
  };
  const set = (k, v) => { if (s[k] !== v) { s[k] = v; render(); } };

  // sessionStorage cache — a paint-time hint ONLY, so the bar renders in the
  // right state before the network resolves. It is never authoritative: it
  // cannot observe a remove made on /cart, a page this script doesn't run on.
  const CART_CACHE_KEY = 'jd_cart_v';
  const readCartCache  = () => { try { return JSON.parse(sessionStorage.getItem(CART_CACHE_KEY) || '[]'); } catch (_) { return []; } };
  const writeCartCache = ids => { try { sessionStorage.setItem(CART_CACHE_KEY, JSON.stringify(ids)); } catch (_) {} };

  let cartIds = readCartCache().map(String);
  const inCart = id => cartIds.includes(String(id));

  const applyCartIds = (ids) => {
    cartIds = ids.map(String);
    writeCartCache(cartIds);
    s.added = inCart(bar.dataset.variantId);
    render();   // render() mirrors s.added onto the native ATC via syncNativeAtc
  };

  // Ask /cart.js for the truth.
  const refreshCart = async () => {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      applyCartIds((cart.items || []).map(it => it.variant_id));
    } catch (_) {}
  };

  // Pre-seed from cache so the bar shows in the correct state before the network
  // resolves. render() isn't called yet, so the native button is left alone until
  // the real cart confirms — an unlocked button is the safe default (a duplicate
  // add just returns 422, which theme.js resolves against the cart).
  s.added = inCart(bar.dataset.variantId);

  // Page-ready gate (400ms grace after DOMContentLoaded), then confirm against
  // the real cart — unconditionally. The old build fetched /cart.js only when
  // the cache key was absent, so a remove performed on /cart left a stale
  // "in cart" entry that kept the ATC button disabled for the rest of the session.
  const ready = () => setTimeout(() => { set('ready', true); refreshCart(); }, 400);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', ready)
    : ready();

  // Back/forward restore. The "Remove" control in snippets/cart-item.liquid is a
  // plain <a href="/cart/change?...&quantity=0"> full navigation, so returning to
  // the PDP replays it from bfcache — same DOM, locked button, and none of the
  // listeners below ever fire. Re-read the cart.
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });

  // Reveal gate — show the bar ONLY once the ADD TO BAG button has scrolled
  // above the top of the viewport (boundingClientRect.bottom <= 0). While the
  // button is visible, or still below the fold on initial load, keep it hidden.
  // threshold:0 fires the callback at each viewport-edge crossing, which is
  // exactly when the reveal state can flip.
  new IntersectionObserver(([e]) => set('revealed', e.boundingClientRect.bottom <= 0), { threshold: 0 }).observe(anchorEl);

  // Track variant changes for in-stock / variant id / thumbnail.
  // Guard: ignore the initial echo that Impulse dispatches on product-form
  // hydration with the *current* variant — otherwise it can override the
  // server-rendered in_stock=false with a stale "true" and flip the bar from
  // sold-out to active. Only react to genuine variant changes.
  document.addEventListener('variant:change', ({ detail }) => {
    const v = detail?.variant;
    if (!v) return;
    if (String(v.id) === String(bar.dataset.variantId)) return;
    s.inStock = !!v.available;
    s.added = inCart(v.id);
    bar.dataset.variantId = v.id;
    const priceEl = bar.querySelector('[data-jd-price]');
    if (priceEl && v.price != null) {
      priceEl.textContent = window.Shopify?.formatMoney?.(v.price) ?? `$${(v.price / 100).toFixed(2)}`;
    }
    // Variant-specific image: swap when present, leave alone otherwise so we
    // don't blank out the product fallback that was rendered server-side.
    const thumb = bar.querySelector('.jd-bar-thumb');
    const variantImg = v.featured_image?.src || v.featured_media?.preview_image?.src;
    if (thumb && variantImg) {
      const url = new URL(variantImg, location.href);
      url.searchParams.set('width', '300');
      thumb.src = url.toString();
    }
    render();
  });

  // Ring-size carry-over — mirrors snippets/jd-ring-size-selector.liquid so the
  // sticky bar uses the same source of truth as the main PDP ATC form. Only
  // applied when the product is a Ring; otherwise we'd risk tagging non-ring
  // items with a stale size from a prior session.
  const RING_STORAGE_KEY    = 'jd_last_ring_size';
  const RING_STORAGE_TTL_MS = 1000 * 60 * 60 * 24 * 90; // 90 days
  const isRing = (bar.dataset.productType || '').toLowerCase() === 'rings';

  const readSavedRingSize = () => {
    try {
      const raw = window.localStorage.getItem(RING_STORAGE_KEY);
      if (!raw) return '';
      if (raw.charAt(0) !== '{') return raw; // back-compat: legacy plain string
      const obj = JSON.parse(raw);
      if (!obj || !obj.v) return '';
      if (obj.t && (Date.now() - obj.t) > RING_STORAGE_TTL_MS) return '';
      return obj.v;
    } catch (e) { return ''; }
  };

  // On-page hidden input wins (it reflects this session's selection); fall
  // back to localStorage so a previously-chosen size still carries over even
  // when the shopper hasn't touched the selector on the current PDP.
  const getRingSizeForCart = () => {
    if (!isRing) return '';
    const hidden = document.querySelector('input[name="properties[customer_ring_size]"]');
    const fromForm = hidden && hidden.value ? String(hidden.value).trim() : '';
    if (fromForm) return fromForm;
    return readSavedRingSize();
  };

  // Add to Bag — direct AJAX, bypasses Impulse's ring-size form validator.
  // Inventory of nearly every item is 1 (one-of-a-kind pieces), so the same
  // variant must never appear on two separate lines. If the variant is
  // already in the cart, update that line's properties in place (e.g. swap
  // ring size) rather than creating a duplicate.
  // Swallow click bubbling from the bar itself so no document-level outside-click
  // handler can interpret bar clicks (e.g. close a drawer). Buttons inside the bar
  // still receive their own clicks first — this only guards the bubble phase.
  bar.addEventListener('click', e => e.stopPropagation());

  bar.querySelector('[data-jd-primary-action]')?.addEventListener('click', async e => {
    e.preventDefault();
    if (bar.dataset.state === 'added') {
      window.location.href = '/cart';
      return;
    }
    if (s.busy || bar.dataset.state !== 'active') return;
    s.busy = true;
    const btn = e.currentTarget;
    btn.disabled = true;

    try {
      const variantId = String(bar.dataset.variantId);
      const ringSize = getRingSizeForCart();

      const cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
      });
      const cart = cartRes.ok ? await cartRes.json() : { items: [] };
      const items = (cart && cart.items) || [];
      const existingIndex = items.findIndex(it => String(it.variant_id) === variantId);

      if (existingIndex !== -1) {
        // Merge: preserve any existing line-item properties (engraving,
        // resizing_fee, etc.) and only overwrite customer_ring_size if we
        // have a fresh value to apply.
        const existing = items[existingIndex];
        const mergedProps = Object.assign({}, existing.properties || {});
        if (ringSize) mergedProps.customer_ring_size = ringSize;

        const changeRes = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            line: existingIndex + 1, // Shopify uses 1-based line indexes
            quantity: existing.quantity || 1,
            properties: mergedProps,
          }),
        });
        if (!changeRes.ok) throw new Error(`HTTP ${changeRes.status}`);
      } else {
        const payload = { id: variantId, quantity: 1 };
        if (ringSize) payload.properties = { customer_ring_size: ringSize };

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
      }

      // Persist to cache so the cart page (and any soft-reloaded PDP) reflect
      // the add immediately, then send the shopper straight to the cart page.
      // ADD (like the already-in-cart VIEW state above) intentionally routes
      // to /cart rather than opening the drawer.
      if (!inCart(variantId)) { cartIds = [...cartIds, variantId]; writeCartCache(cartIds); }
      window.location.href = '/cart';
      return;
    } catch (err) {
      console.error('[jd-sticky-atc] add failed', err);
      // Re-enable so the shopper can retry. The success path navigates away, so
      // this is the only branch that needs to restore the button.
      btn.disabled = false;
    } finally {
      s.busy = false;
    }
  });

  // Inquire ("CONTACT") button — on a sold-out PDP, open the sold-out contact modal
  // (snippets/jd-sold-out-cta.liquid, whose own "CONTACT US" button carries
  // [data-jd-soldout-open]). Only if that modal isn't present do we fall back to the
  // Shopify Inbox chat widget, then the inquire URL.
  bar.querySelector('[data-jd-inquire-action]')?.addEventListener('click', e => {
    e.preventDefault();
    const log = (msg, extra) => console.info('[jd-sticky-atc/chat]', msg, extra ?? '');

    // 0) Prefer the sold-out contact modal — click its trigger to reuse the same
    //    open/prefill/close logic. (This button only shows in the sold-out state.)
    const soldOutTrigger = document.querySelector('[data-jd-soldout-open]');
    if (soldOutTrigger) { log('opening sold-out contact modal'); soldOutTrigger.click(); return; }

    // Selectors that actually exist on Shopify Inbox today (verified 2026-05-25).
    // Listed broadest-first so future tweaks to data-spec/class don't break us.
    const BTN_SELECTORS = [
      'button[data-spec="toggle-button"]',
      'button.chat-toggle',
      'button[part="chat-button"]',
      'button#chat-button',
      'button[aria-label*="chat" i]',
      'button[aria-label*="message" i]',
    ];

    // 1) Direct lookup by the known Shopify Inbox host id.
    const inboxHost = document.getElementById('ShopifyChat')
      || document.querySelector('inbox-online-store-chat, shop-chat, shopify-chat, shopify-agent, shopify-chat-widget, shopify-inbox-chat');

    if (inboxHost?.shadowRoot) {
      for (const sel of BTN_SELECTORS) {
        const btn = inboxHost.shadowRoot.querySelector(sel);
        if (btn) { log('clicked', `#${inboxHost.id || inboxHost.tagName.toLowerCase()} >> ${sel}`); btn.click(); return; }
      }
      log('host found but no matching button inside shadow root', inboxHost);
    } else if (inboxHost) {
      log('host found but shadowRoot is null (declarative shadow DOM may not have attached)', inboxHost);
    }

    // 2) Generic shadow-DOM sweep — last resort for forks/renames.
    for (const el of document.querySelectorAll('*')) {
      if (!el.shadowRoot) continue;
      for (const sel of BTN_SELECTORS) {
        const btn = el.shadowRoot.querySelector(sel);
        if (btn) { log('clicked (sweep)', `${el.tagName.toLowerCase()} >> ${sel}`); btn.click(); return; }
      }
    }

    // 3) Nothing found — fall back to configured URL.
    log('no chat widget detected; falling back to', bar.dataset.inquireFallback);
    if (bar.dataset.inquireFallback) location.href = bar.dataset.inquireFallback;
  });

  // Sync cache + state when a native PDP form adds to cart. The success branch in
  // theme.js carries the variant_id in the event detail, so no /cart.js round-trip
  // is needed; the 422-confirmed branch (jd422Confirmed) dispatches with no detail
  // at all, so fall back to a cart read there rather than dropping the event.
  document.addEventListener('ajaxProduct:added', e => {
    const addedId = e.detail?.product?.variant_id;
    if (!addedId) { refreshCart(); return; }
    if (!inCart(addedId)) applyCartIds([...cartIds, addedId]);
  });

  // Sync cache + state when quantity is changed via the cart drawer or cart page.
  // Impulse dispatches `cart:updated` from the quantity-stepper path only (never on
  // drawer opens), with the parsed cart on event.detail.cart. Note this does NOT
  // cover the "Remove" link — that is a full navigation, handled by the pageshow
  // and page-ready refreshes above.
  document.addEventListener('cart:updated', e => {
    const cart = e.detail?.cart;
    if (!cart || !Array.isArray(cart.items)) { refreshCart(); return; }
    applyCartIds(cart.items.map(it => it.variant_id));
  });

  // Modal/drawer suppression — events + <html> class observer
  OPEN_EVTS.forEach(ev => document.addEventListener(ev, () => set('modalOpen', true)));
  new MutationObserver(() => set('modalOpen', MODAL_CLS.some(c => document.documentElement.classList.contains(c))))
    .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
})();
